'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactRouter = require('react-router');

var _getImage = require('./getImage');

var _getImage2 = _interopRequireDefault(_getImage);

var _Icon = require('../../Icon');

var _Icon2 = _interopRequireDefault(_Icon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CLASS_NAME = 'navigation';

var getNavigation = function getNavigation(navigation) {
  if (navigation) {
    return _react2.default.createElement(
      'div',
      { className: CLASS_NAME },
      _react2.default.createElement(
        'div',
        { className: 'wrapper' },
        _react2.default.createElement(
          'div',
          { className: 'page-container' },
          _react2.default.createElement(
            'div',
            { className: 'tabs' },
            _react2.default.createElement(
              'ul',
              { className: 'tab-list' },
              navigation.map(function (_ref, key) {
                var label = _ref.label,
                    href = _ref.href,
                    image = _ref.image,
                    isSelected = _ref.isSelected;

                var selected = isSelected ? 'selected' : null;
                var iconColor = isSelected ? "#FF6138" : "#3D4143";

                var classNames = [CLASS_NAME + '-item', selected].join(' ');

                return _react2.default.createElement(
                  'li',
                  {
                    key: key,
                    className: classNames
                  },
                  _react2.default.createElement(
                    _reactRouter.Link,
                    {
                      to: href,
                      className: selected
                    },
                    _react2.default.createElement(
                      'div',
                      { className: 'nav' },
                      _react2.default.createElement(
                        'div',
                        { className: 'navigation-item-img-hold' },
                        _react2.default.createElement(_Icon2.default, { iconName: image, color: iconColor, height: 42 })
                      ),
                      _react2.default.createElement(
                        'span',
                        null,
                        label
                      )
                    )
                  )
                );
              })
            )
          )
        )
      )
    );
  }

  return null;
};

exports.default = getNavigation;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/shared/components/Page/utils/getNavigation.js
// module id = 1106
// module chunks = 0